import { useState, useEffect } from "react";
import supabase from "../lib/supabase";

export function useBouquetTypes() {
  const [types, setTypes] = useState([]);

  useEffect(() => {
    // Only used inside the navbar mega-menu (interaction). Defer until idle
    // so the homepage hero render isn't held up by this query.
    const runFetch = () =>
      supabase
        .from("bouquet")
        .select("bouquet_type")
        .eq("is_available", true)
        .then(({ data }) => {
          const seen = new Set();
          const flat = [];
          for (const row of data ?? []) {
            for (const t of row.bouquet_type ?? []) {
              const key = t.trim().toLowerCase();
              if (key && !seen.has(key)) {
                seen.add(key);
                flat.push(t.trim());
              }
            }
          }
          setTypes(flat.sort());
        });

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const id = window.requestIdleCallback(runFetch, { timeout: 2000 });
      return () => window.cancelIdleCallback?.(id);
    }
    const t = setTimeout(runFetch, 1500);
    return () => clearTimeout(t);
  }, []);

  return types;
}
